'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureStore;

var _redux = require('redux');

var _socketClient = require('../utils/socket/socketClient');

var _getMiddleware = require('./getMiddleware');

var _getMiddleware2 = _interopRequireDefault(_getMiddleware);

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _reduxBulkingMiddleware = require('./reduxBulkingMiddleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(initialState, browserHistory, elementConnectionsManager) {
    var socketManager = (0, _socketClient.getSocketManager)();

    var middlewareList = (0, _getMiddleware2.default)({
        browserHistory: browserHistory,
        socketManager: socketManager,
        elementConnectionsManager: elementConnectionsManager
    });

    var middleware = _redux.applyMiddleware.apply(null, middlewareList);

    var store = (0, _redux.createStore)((0, _reduxBulkingMiddleware.enableReducerBatching)(_reducers2.default), initialState, middleware);
    socketManager.subscribeToStore(store);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', function () {
            var nextReducer = require('../reducers');
            store.replaceReducer(nextReducer);
        });
    }

    return store;
}


//////////////////
// WEBPACK FOOTER
// ./src/client/store/configureStoreWeb.js
// module id = 2049
// module chunks = 0